/**
 * Clipboard utility for copying text to clipboard with visual feedback
 */

export function initClipboardButtons() {
  // Find all copy buttons with data-clipboard-selector attribute
  const copyButtons = document.querySelectorAll('[data-clipboard-selector]');

  copyButtons.forEach(button => {
    // Skip if already initialized
    if (button.dataset.clipboardInitialized === 'true') {
      return;
    }

    button.dataset.clipboardInitialized = 'true';

    button.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();

      const selector = button.getAttribute('data-clipboard-selector');
      const target = document.querySelector(selector);

      if (!target) {
        console.error(`Clipboard target not found: ${selector}`);
        showClipboardError(button);
        return;
      }

      const textToCopy = target.innerText || target.textContent;

      if (!textToCopy || textToCopy.trim() === '') {
        console.error('No text to copy');
        showClipboardError(button);
        return;
      }

      try {
        // Copy to clipboard
        await navigator.clipboard.writeText(textToCopy);

        // Show success feedback
        showClipboardSuccess(button);
      } catch (err) {
        console.error('Failed to copy to clipboard:', err);
        showClipboardError(button);
      }
    });
  });
}

/**
 * Show success feedback on copy button
 */
function showClipboardSuccess(button) {
  // Store original content
  const originalText = button.innerHTML;
  const originalClass = button.className;

  // Update button to show success with copy + checkmark icons
  button.classList.remove('btn-outline-secondary');
  button.classList.add('btn-success');

  button.innerHTML = '<i class="fas fa-copy me-1"></i><i class="fas fa-check"></i>Copied!';

  // Revert after 2 seconds
  setTimeout(() => {
    button.className = originalClass;
    button.innerHTML = originalText;
  }, 2000);
}

/**
 * Show error feedback on copy button
 */
function showClipboardError(button) {
  const originalClass = button.className;
  const originalHTML = button.innerHTML;

  button.classList.remove('btn-outline-secondary');
  button.classList.add('btn-danger');
  button.innerHTML = '<i class="fas fa-exclamation-circle me-1"></i>Failed!';

  setTimeout(() => {
    button.className = originalClass;
    button.innerHTML = originalHTML;
  }, 2000);
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', initClipboardButtons);
